import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const PAYMENT_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SUB_ORDER_REASONS: '/sub-order-reasons/',
    FINANCIAL_TRANSACTIONS_TYPES: '/admin/financial-transactions-types/',
    CALCULATE_SUB_ORDER_AMOUNT: '/calculate-sub-order-amount/',
    CREATE_INSPECTOR_FINANCIAL_TRANSACTION: '/admin/create-inspector-financial-transaction/',
    INSPECTOR_FINANCIAL_TRANSACTIONS: (orderId: number) => `/admin/inspector-financial-transactions/${orderId}/`,
    CREATE_SUB_ORDER: '/create-sub-order/',
    PAYMENT_METHODS: '/payment-methods/',
    ORDER_PURCHASE: (id: number) => `/admin/orders/${id}/purchase/`,
  }),
} as const;
